import React from 'react';
import Banner from '../../../components/Banner/Banner';
import './Egitim.css';

const Egitim = () => {
  const egitimHTML = `
<div data-elementor-type="wp-page" class="elementor elementor-page">
  <section class="elementor-section elementor-top-section elementor-element elementor-section-boxed elementor-section-height-default elementor-section-height-default">
    <div class="elementor-container elementor-column-gap-default">
      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-widget elementor-widget-heading">
            <div class="elementor-widget-container">
              <h2 class="elementor-heading-title elementor-size-default">Eğitim Hizmetlerimiz</h2>
            </div>
          </div>
          <div class="elementor-element elementor-widget elementor-widget-text-editor">
            <div class="elementor-widget-container">
              <p>Teknoma, farklı endüstriyel alanlarda uzman ekibiyle eğitim hizmetleri sunmaktadır:</p>
              <ul>
                <li>İnce Film Teknolojileri</li>
                <li>Vakum Sistemleri</li>
                <li>Kaplama Teknolojileri</li>
                <li>Malzeme Karakterizasyon Teknikleri</li>
                <li>Özel Uygulama Çözümleri</li>
              </ul>
              <p>Eğitim programlarımız hakkında detaylı bilgi için lütfen bizimle iletişime geçiniz.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
  `;

  return (
    <div className="egitim-page">
      {/* Banner */}
      <Banner 
        title="Eğitim Hizmetleri" 
        backgroundImage="https://teknoma.net/wp-content/themes/bizler/assets/img/inner-banner.jpg"
      />

      {/* Page Content */}
      <section className="egitim-content">
        <div className="container content-container">
          <div dangerouslySetInnerHTML={{ __html: egitimHTML }} />
        </div>
      </section>
    </div>
  );
};

export default Egitim;